import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { initMonitoring } from './lib/monitoring';

import './design/fonts';
import './design/tokens.css';
import './design/base.css';

// Error monitoring first, so a failure during startup is still reported.
// No-op when no DSN is configured, which is the normal state today.
initMonitoring();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
